export default __webpack_public_path__ + "static/media/aside-vip-logo-gold.debdf220.webp";